// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"PageContainer_pageContainer__2bQ-4"};